import { render, staticRenderFns } from "./DoorLockDamage.vue?vue&type=template&id=27872d60&scoped=true"
import script from "./DoorLockDamage.vue?vue&type=script&lang=ts"
export * from "./DoorLockDamage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27872d60",
  null
  
)

export default component.exports